import { Announcement03, FilePlus02, MessageTextSquare02, Tag01, UserX01, XCircle } from "@untitledui/icons";
import type { ActionMenuGroup } from "@/components/action-menu/grouped-action-menu";

export type CreatorActionGroupsOptions = {
  onInvite: () => void;
  onMessage: () => void;
  onAddToList: () => void;
  onAddToCohort: () => void;
  onBlock: () => void;
  onRemove: () => void;
  cohortsEnabled: boolean;
  blocklistEnabled: boolean;
};

/**
 * Action groups for a creator the brand has already collaborated with — the "Collaborate" /
 * "Organize" / (untitled Block+Remove) set from the Figma. Every caller resolves its own flags
 * and handlers; this only arranges them so the grouping/order stays identical across the 7
 * surfaces that use it (UNB-2816).
 */
export const buildCreatorActionGroups = ({
  onInvite,
  onMessage,
  onAddToList,
  onAddToCohort,
  onBlock,
  onRemove,
  cohortsEnabled,
  blocklistEnabled,
}: CreatorActionGroupsOptions): ActionMenuGroup[] => [
  {
    label: "Collaborate",
    items: [
      { key: "invite", icon: Announcement03, label: "Invite to another collaboration", onSelect: onInvite },
      { key: "message", icon: MessageTextSquare02, label: "Message Creator on TikTok", onSelect: onMessage },
    ],
  },
  {
    label: "Organize",
    items: [
      { key: "add-to-list", icon: FilePlus02, label: "Add to creator list", onSelect: onAddToList },
      {
        key: "add-to-cohort",
        icon: Tag01,
        label: "Add to cohort",
        onSelect: onAddToCohort,
        hidden: !cohortsEnabled,
      },
    ],
  },
  {
    items: [
      { key: "block", icon: UserX01, label: "Block creator", onSelect: onBlock, hidden: !blocklistEnabled },
      { key: "remove", icon: XCircle, label: "Remove from collaborations", onSelect: onRemove },
    ],
  },
];

export type CandidateActionGroupsOptions = {
  onInvite: () => void;
  onMessage: () => void;
  onAddToList: () => void;
};

/**
 * Action groups for a candidate the brand has never collaborated with — no Block/Remove block,
 * since there's no relationship yet to end.
 */
export const buildCandidateActionGroups = ({
  onInvite,
  onMessage,
  onAddToList,
}: CandidateActionGroupsOptions): ActionMenuGroup[] => [
  {
    label: "Collaborate",
    items: [
      { key: "invite", icon: Announcement03, label: "Invite to collaborate", onSelect: onInvite },
      { key: "message", icon: MessageTextSquare02, label: "Message Creator on TikTok", onSelect: onMessage },
    ],
  },
  {
    label: "Organize",
    items: [{ key: "add-to-list", icon: FilePlus02, label: "Add to Find creator list", onSelect: onAddToList }],
  },
];
